import { Flag, useFlag } from 'pkg/flags';

/**
 *	Whether this browser can draw v2. Every Playbook stylesheet sits in a
 *	cascade layer, and a browser without layers (iOS before 15.4) drops them
 *	all, which leaves v2 unstyled. Playbook's menus, date picker and bottom bar
 *	are popovers, which a browser without the Popover API (iOS and Safari
 *	before 17) can't open (PLA-763). Those browsers get v1 whatever the flag
 *	says.
 */
export function supportsChatV2(): boolean {
	return (
		typeof window !== 'undefined' &&
		'CSSLayerBlockRule' in window &&
		'showPopover' in HTMLElement.prototype
	);
}

/** Whether chat shows v2: the `chat_v2` flag, on a browser that can draw it. */
export function useChatV2(): boolean {
	const chatV2 = useFlag<boolean>(Flag.ChatV2);

	return chatV2 && supportsChatV2();
}
